var extVsMime = {
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  ico: 'image/vnd.microsoft.icon',
  svg: 'image/svg+xml',
  webp: 'image/webp',
  anyimage: 'image/*',
  mp4: 'video/mp4',
  mov: 'video/quicktime',
  avi: 'video/x-msvideo',
  wmv: 'video/x-ms-wmv',
  mkv: 'video/x-matroska',
  mpeg: 'video/mpeg',
  ogv: 'video/ogg',
  webm: 'video/webm',
  // recorded video is having this content type.
  // TO-DO - check if there is any way to send basic webm content type(video/webm) in recorded media.
  webm2: 'application/x-matroska',
  ts: 'video/mp2t',
  flv: 'video/x-flv',
  aac: 'audio/aac',
  mp3: 'audio/mpeg',
  wav: 'audio/wav',
  weba: 'audio/webm',
  oga: 'audio/ogg',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  pdf: 'application/pdf',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  rtf: 'application/rtf',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  json: 'application/json',
  csv: 'text/csv',
  txt: 'text/plain',
  html: 'text/html',
  zip: 'application/zip',
  bai2: 'text/plain',
  ttf: 'font/ttf'
};
export default extVsMime;